import { PostStatDto, PostStatModel } from '../../data-layer/posts/types';

export const toPostStatisticModel = (postStatDto: PostStatDto): PostStatModel => postStatDto;
